import { API } from 'aws-amplify';

export class CreateAPI {
  constructor({ apiName, requestInterceptors, errorInterceptors, apiPath }) {
    this.apiName = apiName;
    this.apiPath = apiPath;
    this.requestInterceptors = requestInterceptors || [];
    this.errorInterceptors = errorInterceptors;

    this.methods = {
      get: 'get',
      post: 'post',
      put: 'put',
      del: 'del',
      patch: 'patch',
    };

    const defaultConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    // Adicionar métodos dinamicamente para métodos HTTP
    Object.values(this.methods).forEach(method => {
      this[method] = async (endpoint = '', config = defaultConfig) => {
        // To use in post like apiName.post({ ...data })
        if (typeof endpoint === 'object') {
          config = endpoint;
          endpoint = '';
        }

        const endpointWithApiPath = this.apiPath
          ? `${this.apiPath}${endpoint}`
          : endpoint;

        return this.call(
          endpointWithApiPath,
          {
            ...defaultConfig,
            ...config,

            headers: {
              ...defaultConfig.headers,
              ...config?.headers,
            },
          },
          this.methods[method]
        );
      };
    });
  }

  async call(endpoint, config, method) {
    let updatedConfig = { ...config };

    try {
      // Interceptadores antes da chamada
      for (const interceptor of this.requestInterceptors) {
        updatedConfig = await interceptor(updatedConfig);
      }

      return await API[method](this.apiName, endpoint, updatedConfig);
    } catch (error) {
      let result;

      try {
        // Interceptadores pós erro
        for (const interceptor of this.errorInterceptors) {
          result = await interceptor({
            error: error.request,
            fn: async config =>
              API[method](this.apiName, endpoint, {
                ...updatedConfig,
                ...config,
                headers: {
                  ...updatedConfig.headers,
                  ...config.headers,
                },
              }),
            response: null,
          });
        }
      } catch (error) {
        console.error(error);
        throw error;
      }

      if (result.response) return result.response;

      throw error;
    }
  }
}
